'use strict'

angular
  .module('basalteApp')
  .constant('BAS_APP_HEADER', {
    EVT_STATE_CHANGED: 'evtBasAppHeaderStateChanged'
  })
